import { SET_SCHEDULE_PREFERENCE_ENABLED } from 'actions';

export function setSchedulePreferenceEnabled(
  schedulePreferenceEnabled: boolean,
) {
  return { schedulePreferenceEnabled, type: SET_SCHEDULE_PREFERENCE_ENABLED };
}
